const blobToDataUrl = (blob) =>
  new Promise((resolve) => {
    try {
      if (!blob) {
        resolve(null);
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        resolve(typeof result === "string" && result ? result : null);
      };
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    } catch {
      resolve(null);
    }
  });

const imageElementToDataUrl = (url) =>
  new Promise((resolve) => {
    try {
      if (!url) {
        resolve(url);
        return;
      }
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const width = img.naturalWidth || img.width;
          const height = img.naturalHeight || img.height;
          if (!width || !height) {
            resolve(url);
            return;
          }
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            resolve(url);
            return;
          }
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/jpeg", 0.92));
        } catch {
          resolve(url);
        }
      };
      img.onerror = () => resolve(url);
      img.src = url;
    } catch {
      resolve(url);
    }
  });

export const urlToPrintableSrc = async (url) => {
  if (!url) return "";
  if (String(url).startsWith("data:")) return url;
  try {
    const res = await fetch(url, { mode: "cors", credentials: "omit" });
    if (!res?.ok) throw new Error("Image fetch failed");
    const blob = await res.blob();
    const dataUrl = await blobToDataUrl(blob);
    return dataUrl || url;
  } catch {
    try {
      return (await imageElementToDataUrl(url)) || url;
    } catch {
      return url;
    }
  }
};

export const normalizeFileUrl = (fle) => {
  try {
    if (!fle) return "";
    if (typeof fle === "string") return fle.trim();
    const url = fle?.url ?? fle?.fileUrl ?? fle?.file ?? "";
    return typeof url === "string" ? url.trim() : "";
  } catch {
    return "";
  }
};
